<template>
  <div class="now-result">

    <div class="result-head">
      <h1>{{ lottoDate | date }}</h1>
      <h2>Winning Number</h2>
    </div>

    <div class="result-body">
      <div class="result-box">
        <EmptyNumbers v-if="status===0" />
        <SpinNumbers v-else-if="status===1" :startShow="startShow" :resultNumbers="resultNumbers" />
        <ShowSuccessResult v-else-if="status===2" :resultNumbers="resultNumbers" />
      </div>
    </div>

    <div class="result-countdown">{{ countTimer }}</div>
  </div>
</template>
<script>
import moment from "@/moment"

import LottoService from "@/services/lottoService"

import EmptyNumbers from './EmptyNumbers.vue'
import SpinNumbers from './SpinNumbers.vue'
import ShowSuccessResult from './ShowSuccessResult.vue'

export default {
  name: 'TodayResult',
  components: {
    EmptyNumbers,
    SpinNumbers,
    ShowSuccessResult
  },
  data() {
    return {
      data: null,
      status: 0,
      Interval: null,
      setTimeout: null,
      countTimer: '00:00:00',
      cdInterval: null
    }
  },
  computed: {
    lottoDate() {
      if (this.data) {
        return this.data.lotto_date
      } else {
        return ''
      }
    },
    startShow() {
      if (this.data) {
        return this.data.show_result
      } else {
        return null
      }
    },
    resultNumbers() {
      if (this.results) {
        return this.results.digit5
      } else {
        return null
      }
    },
    results() {
      if (this.data) {
        return this.data.results
      } else {
        return null
      }
    },
    showTime() {
      if (this.results) {
        return moment(this.data.show_result).format("HH:mm")
      } else {
        return '--'
      }
    }
  },
  methods: {
    loadResult() {
      LottoService.nowResult().then((response) => {
        if (response.status === 'success') {
          this.data = response.data
          this.calProcess()
        }
      })
    },
    calProcess() {
      let successTime = moment(this.data.show_result).add(1, 'seconds')
      // ยังไม่ถึงเวลาเริ่มหมุน
      if (moment().isBefore(this.data.start_spin)) {
        this.status = 0
        clearTimeout(this.setTimeout)
        let diff = moment(this.data.start_spin).diff(moment(), 'milliseconds') + 1000
        this.setTimeout = setTimeout(() => {
          this.calProcess()
        }, diff)
      } else
      if (this.data.start_spin && this.data.show_result && moment().isBetween(this.data.start_spin, successTime)) {
        // อยู่ระหว่างหมุนออกรางวัล
        this.status = 1
        clearTimeout(this.setTimeout)
        let diff = moment(this.data.show_result).diff(moment(), 'milliseconds') + 1000
        this.setTimeout = setTimeout(() => {
          this.calProcess()
        }, diff)
      } else
      if (moment().isAfter(this.data.start_spin) && !this.data.show_result) {
        // กำลังหมุนออกรางวัล แต่ไม่ได้ตั้งเวลาออกผล
        this.status = 1
      } else
      if (moment().isAfter(this.data.show_result)) {
        // ถึงเวลาออกผลแล้ว
        let results = this.data.results
        if (results.digit5) {
          // ออกผลเสร็จหมดแล้ว
          if (moment().isAfter(successTime)) {
            this.status = 2
          } else {
            // กำลังอยู่ในขั้นตอนแสดงผลที่ล่ะชุดตัวเลข
            let diff = moment(successTime).diff(moment(), 'milliseconds') + 500
            this.setTimeout = setTimeout(() => {
              this.calProcess()
            }, diff)
          }
          // เลยเวลาออกผล แต่ไม่มีผลมา
        } else {
          this.status = 1
          clearTimeout(this.setTimeout)
          this.setTimeout = setTimeout(() => {
            this.loadResult()
          }, 10000)
        }
      }

      clearInterval(this.cdInterval)
      this.countdown()
      this.cdInterval = setInterval(() => {
        this.countdown()
      }, 1000)
    },
    countdown() {
      let diff = moment(this.data.show_result).diff(moment(), 'milliseconds')
      if(diff > 0) {
        let duration = moment.duration(diff, 'milliseconds')
        let d = moment.duration(duration).days(),
            h = moment.duration(duration).hours(),
            m = moment.duration(duration).minutes(),
            s = moment.duration(duration).seconds()

        if(d > 0) h = (d*24) + h
        if(h < 10) h = `0${h}`
        if(m < 10) m = `0${m}`
        if(s < 10) s = `0${s}`
        this.countTimer = `${h}:${m}:${s}`
      }else{
        this.countTimer = moment(this.data.show_result).format("HH:mm:ss")
        clearInterval(this.cdInterval)
      }
    }
  },
  created() {
    this.loadResult()
    this.Interval = setInterval(() => {
      this.loadResult()
    }, 60000)
  },
  filters: {
    date(param) {
      if (param) {
        return moment(param).format("dddd, MMM DD, YYYY")
      } else {
        return '-'
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.Interval)
    clearTimeout(this.setTimeout)
  }
}

</script>
<style lang="scss">
.now-result {

  .result-head {
    margin-top: 20px;
    margin-bottom: 10px;

    h1 {
      text-align: center;
      color: #FFFFFF;
      font-size: 2rem;
      margin-bottom: 25px;
    }

    h2 {
      text-align: center;
      font-size: 1.2rem;
      margin: 0;
      font-weight: bold;
      color: #FFFFFF;
    }
  }

  .result-body {
    display: flex;
    justify-content: center;
    align-items: center;

    .result-box {
      background-color: #0D0D33;
      border: 2px solid #40434A;
      border-radius: 10px;
      padding: 10px;

      .c-numbers {
        display: flex;

        .c-number {
          padding: 0 2px;

          img {
            width: 60px;
          }
        }
      }
    }
  }

  .result-countdown {
    text-align: center;
    color: #AAAAAA;
    font-size: 1.2rem;
    letter-spacing: 0.3rem;
  }
}

@media only screen and (max-width:500px) {
  .now-result {
    .result-head {
      h1 {
        font-size: 1.5rem;
      }

      h2 {
        font-size: 1rem;
      }
    }

    .result-body {
      .result-box {
        padding: 8px;
        .c-numbers {
          .c-number {
            padding: 0 2px;
            img {
              width: 50px;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width:300px) {
  .now-result {
    .result-head {
      h1 {
        font-size: 1.2rem;
      }

      h2 {
        font-size: 1rem;
      }
    }

    .result-body {
      .result-box {
        padding: 5px;
        .c-numbers {
          .c-number {
            padding: 0 1px;
            img {
              width: 40px;
            }
          }
        }
      }
    }
  }
}
</style>
